import axios from 'axios'
import { getHost } from './host'

interface ReportTemplates {
  data: ReportTemplate;
  _meta: any;
}

export interface ReportTemplate {
  id: number;
  account_id: number;
  type_id: number;
  subtype_id: number;
  title: string;
  format: string;
  period: string;
  structure: any;
  created: string;
}

export async function getReportTemplate(api_key: string, report_template_id: number) {
  const url = `https://${getHost()}/api/templates/${report_template_id}`

  const { data } = await axios.get<ReportTemplate>(url, { headers: {'X-API-KEY': api_key, Accept: 'application/json'} });
  return data
}

export async function getReportTemplates(api_key: string, station_id: number = null) {
  const url = `https://${getHost()}/api/templates`

  let params = {}
  
  if (station_id !== null) {
    params['station_id'] = station_id
  }

  const { data } = await axios.get<ReportTemplates[]>(
    url, 
    { 
      headers: {'X-API-KEY': api_key, Accept: 'application/json'},
      params: params
    }
  );
  
  // return data
  return data.map(template => ({...template.data}));
}